<div class="row mb-2 d-flex align-items-center">
  <div class="col cursor-pointer" (click)="openStayDrawer.emit()">
    <div class="row">
      <div class="col-6 text-truncate">
        {{ userName }}
      </div>
      <div class="col-6 text-truncate user-name d-flex justify-content-end">
        {{ date | date: DateTimeFormat.GermanDateTimeFormat }}
      </div>
    </div>
    <div class="row stay-detail">
      <div class="col text-truncate">
        {{ locationName }}
      </div>
      @if (cancellationDate) {
        <div class="col-8 text-truncate address d-flex justify-content-end">
          {{
            'page.shift_timeline.hotel_stay.drawer.form.cancellation_date'
              | translate
          }}
          {{ cancellationDate | date: DateTimeFormat.GermanDateTimeFormat }}
        </div>
      }
    </div>
  </div>
  <div
    class="col-1 p-0 cursor-pointer"
    (click)="navigateToTimeline.emit()"
    nz-tooltip
    [nzTooltipTitle]="'page.timeline.navigate_to_timeline' | translate"
  >
    <fa-icon [icon]="faCalendarStar"></fa-icon>
  </div>
</div>
